const handleApiError = async (response) => {
  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      localStorage.removeItem('token');
      localStorage.removeItem('currentUser');
      window.location.reload();
      throw new Error('Oturum süresi doldu veya yetkiniz yok.');
    }
    const errorData = await response.json();
    throw new Error(errorData.message || 'Hata oluştu');
  }
};

export const fetchPeriodicalDuesSummaries = async (filters = {}) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/periodical-dues-summaries?` + new URLSearchParams(filters), {
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
  });
  await handleApiError(response);
  return response.json();
};

export const generateAllDuesForPeriod = async (period, buildingId, blockId) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/periodical-dues-summaries/generate`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ period, buildingId, blockId }),
  });
  await handleApiError(response);
  return response.json();
};

export const recordPayment = async (summaryId, paymentData) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/periodical-dues-summaries/${summaryId}/payments`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(paymentData),
  });
  await handleApiError(response);
  return response.json();
};

export const fetchPaymentHistory = async (summaryId) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/periodical-dues-summaries/${summaryId}/payment-history`, {
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
  });
  await handleApiError(response);
  return response.json();
};

export const updatePaymentHistory = async (paymentId, paymentData) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/periodical-dues-summaries/payment-history/${paymentId}`, {
    method: 'PUT',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(paymentData),
  });
  await handleApiError(response);
  return response.json();
};

export const deletePaymentHistory = async (paymentId) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/periodical-dues-summaries/payment-history/${paymentId}`, {
    method: 'DELETE',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
  });
  await handleApiError(response);
};

export const deleteDuesForPeriod = async (period, buildingId, blockId) => {
  const filters = { period };
  if (buildingId) filters.buildingId = buildingId;
  if (blockId) filters.blockId = blockId;

  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/periodical-dues?` + new URLSearchParams(filters), {
    method: 'DELETE',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
  });
  await handleApiError(response);
  return response.json(); // Backend returns a message and rowsAffected
};
